<template>
  <section v-editable="cms" :class="[name, spacing]">
    <grid
      :class="[{ 'grid--container': !fullwidth }, `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__grid-image`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 11 },
          { size: 1, x: 1, width: 12, reverse: true },
          { size: 3, x: 14, width: 11, reverse: true, order: 1 },
        ]"
      >
        <a-image-v2
          v-if="(cms.image || {}).filename"
          :src="(cms.image || {}).filename"
          :alt="(cms.image || {}).alt"
          :class="`${name}__image`"
          :layout="[
            { size: 0, bound: 498 },
            { size: 1, bound: 689 },
            { size: 2, bound: 413 },
            { size: 3, bound: 496 },
            { size: 4, bound: 576 },
          ]"
        />
      </grid-item>
      <grid-item
        :reverse="reverse"
        :class="[`${name}__grid-item`, `${name}__grid-content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 14, width: 11 },
          { size: 1, x: 1, width: 12, reverse: true },
          { size: 3, x: 1, width: 11, reverse: true },
        ]"
      >
        <a-copy :cms="cms" :class="`${name}__content`" />
      </grid-item>
    </grid>
  </section>
</template>

<script>
import Colors from '~/mixins/colors'
import data from '~/components/molecules/m-articles/m-article-with-image.data'

export default {
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'm-article-with-image',
    }
  },

  computed: {
    reverse() {
      return this.cms.reverse || false
    },
    spacing() {
      return this.cms.spacing
    },
    fullwidth() {
      return this.cms.fullwidth || false
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-article-with-image {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: transparent;
  padding: 30px 0;

  &__grid {
    align-items: center;
  }

  &__image {
    ::v-deep img,
    ::v-deep picture {
      margin-bottom: 30px;
    }
  }
}

@include media-breakpoint-up(md) {
  .m-article-with-image {
    &__image {
      ::v-deep img,
      ::v-deep picture {
        margin-bottom: initial;
      }
    }
  }
}
</style>
